import { Action } from '@ngrx/store';

import { QueryParamsModel } from '../../_base/crud';
import { Condition } from '../_models/condition.model';
import { Update } from '@ngrx/entity';

export enum ConditionActionTypes {
  ConditionOnServerCreated = '[Edit Condition Dialog] Condition On Server Created',
  ConditionCreated = '[Edit Condition Dialog] Condition Created',
  ConditionOnServerUpdated = '[Edit Condition Dialog] Condition On Server Updated',
  ConditionUpdated = '[Condition Dialog] Condition Updated',
  ConditionOnServerDeleted = '[Condition List Page]  One Condition On Server Deleted',
  ConditionPageRequested = '[Conditions List Page] Conditions Page Requested',
  ConditionPageLoaded = '[Conditions API] Contact Conditions Page Loaded',
  ConditionPageToggleLoading = '[Condition] Condition Loading',
  ThrowConditionError = '[Condition] Throw Condition Error',
  ClearConditionErrors = '[Condition] Clear Contact Errors',
  ConditionActionToggleLoading = '[Condition] Condition Action Toggle Loading',
  ConditionDeleted = '[Condition List Page] Condition Deleted',
}

export class ConditionPageRequested implements Action {
  readonly type = ConditionActionTypes.ConditionPageRequested;

  constructor(public payload: { page: QueryParamsModel; entityId: number; viewContext }) {}
}

export class ConditionPageLoaded implements Action {
  readonly type = ConditionActionTypes.ConditionPageLoaded;

  constructor(public payload: { conditions: Condition[]; totalCount: number }) {}
}

export class ConditionOnServerCreated implements Action {
  readonly type = ConditionActionTypes.ConditionOnServerCreated;

  constructor(public payload: { condition: Condition; entityId: number }) {}
}

export class ConditionOnServerUpdated implements Action {
  readonly type = ConditionActionTypes.ConditionOnServerUpdated;

  constructor(public payload: { condition: Condition; entityId: number }) {}
}

export class ConditionDeleted implements Action {
  readonly type = ConditionActionTypes.ConditionDeleted;
  constructor(public payload: { condition_id: number }) {}
}

export class ConditionUpdated implements Action {
  readonly type = ConditionActionTypes.ConditionUpdated;

  constructor(
    public payload: {
      condition: Update<Condition>;
    },
  ) {}
}

export class ThrowConditionError implements Action {
  readonly type = ConditionActionTypes.ThrowConditionError;

  constructor(public payload: { error: any }) {}
}

export class ConditionOnServerDeleted implements Action {
  readonly type = ConditionActionTypes.ConditionOnServerDeleted;

  constructor(public payload: { condition_id: number }) {}
}

export class ConditionPageToggleLoading implements Action {
  readonly type = ConditionActionTypes.ConditionPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ConditionActionToggleLoading implements Action {
  readonly type = ConditionActionTypes.ConditionActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ConditionCreated implements Action {
  readonly type = ConditionActionTypes.ConditionCreated;

  constructor(public payload: { condition: Condition }) {}
}

export class ClearConditionErrors implements Action {
  readonly type = ConditionActionTypes.ClearConditionErrors;
}

export type ConditionActions =
  | ConditionPageRequested
  | ConditionPageLoaded
  | ConditionOnServerCreated
  | ConditionOnServerUpdated
  | ConditionOnServerDeleted
  | ConditionPageToggleLoading
  | ConditionCreated
  | ClearConditionErrors
  | ThrowConditionError
  | ConditionUpdated
  | ConditionDeleted
  | ConditionActionToggleLoading;
